export default {
    "edit-external-entity": "Edit external entity",
    "add-new-entity": "Add new entity",
    "addresses": "Addresses",
    "this-entity-data": "this entity data",
    "new-entity-external": "new entity external",
    "customersTab": {
        doctor: "Doctor",
        pharmacy: "Pharmacy",
        center: "Center"
    }
}